import { NotificationList } from '../../components/NotificationList/NotificationList';
export const NotificationPage = () => {
  return (
    <NotificationList />
  );
};
